import React from "react";
import FormTable from "./FormTable";
import { INTERNAL_EMPLOYEE_FORM_ID } from "../../constants/constants";

const Columns: any = [
  {
    id: "employeeName",
    label: "Employee Name",
    align: "left",
    minWidth: 120,
  },
  {
    id: "employeeDesignation",
    label: "Employee Designation",
    align: "left",
    minWidth: 120,
  },
  {
    id: "employeeDepartment",
    label: "Employee Department",
    align: "left",
    minWidth: 120,
  },
  {
    id: "location",
    label: "Location",
    align: "left",
    minWidth: 120,
  },
];

function InternalEmployeeRegistration() {
  return (
    <div>
      <FormTable formId={INTERNAL_EMPLOYEE_FORM_ID} columns={Columns} />
    </div>
  );
}

export default InternalEmployeeRegistration;
